// Shared route → chunk loader map. Webpack dedupes these dynamic imports with the
// lazy() factories in App.js, so calling a loader here warms that page's chunk.
export const ROUTE_LOADERS = {
  "/": () => import("@/pages/Dashboard"),
  "/daily-logs": () => import("@/pages/DailyLogs"),
  "/daily-logs/new": () => import("@/pages/DailyLogNew"),
  "/equipment": () => import("@/pages/Equipment"),
  "/checklists": () => import("@/pages/Checklists"),
  "/checklist-records": () => import("@/pages/ChecklistRecords"),
  "/parts": () => import("@/pages/Parts"),
  "/consumption": () => import("@/pages/Consumption"),
  "/stock": () => import("@/pages/Stock"),
  "/health": () => import("@/pages/Health"),
  "/daily-reports": () => import("@/pages/DailyReports"),
  "/calendar": () => import("@/pages/Calendar"),
  "/documents": () => import("@/pages/Documents"),
  "/job-site-pictures": () => import("@/pages/JobSitePictures"),
  "/master": () => import("@/pages/Master"),
  "/settings": () => import("@/pages/Settings"),
};

const seen = new Set();
export const preloadRoute = (to) => {
  if (seen.has(to)) return;
  const loader = ROUTE_LOADERS[to];
  if (loader) {
    seen.add(to);
    loader().catch(() => seen.delete(to));
  }
};

export const preloadAllRoutes = () => {
  Object.keys(ROUTE_LOADERS).forEach(preloadRoute);
};
